import React from 'react';
import PropTypes from 'prop-types';
import { BanjoString } from '@stashinvest/react-banjo';
import { Flex } from '@stashinvest/ui/dist/es/2';
import { ButtonStandard, Text } from '@stashinvest/react-components';

const LinkPlaidReason = ({ reason, dismiss }) => {
	const REASON = {
		UNSPECIFIED: 'unspecified',
		BALANCE_INSUFFICIENT: 'balanceInsufficient',
		OWNER_MISMATCH: 'ownerMismatch',
		BANK_FORBIDDEN: 'bankForbidden',
		ACCOUNT_FORBIDDEN: 'accountForbidden',
		FAILS_FINRA_REQUIREMENTS: 'failsFinraRequirements',
	};

	function renderContext(reason) {
		switch (reason) {
			case REASON.UNSPECIFIED:
				return <BanjoString stringId={'information/instruct/linkBankManualDifferent'} />;
			case REASON.BALANCE_INSUFFICIENT:
				return <BanjoString stringId={'information/instruct/linkBankSufficientCash'} />;
			case REASON.OWNER_MISMATCH:
				return <BanjoString stringId={'information/instruct/linkBankNameMatch'} />;
			case REASON.BANK_FORBIDDEN:
				return <BanjoString stringId={'information/instruct/linkDifferentBank'} />;
			case REASON.ACCOUNT_FORBIDDEN:
				return <BanjoString stringId={'information/instruct/linkBankDifferentAccount'} />;
			case REASON.FAILS_FINRA_REQUIREMENTS:
				return <BanjoString stringId={'information/instruct/linkBankAccountOwner'} />;
			default:
				return <BanjoString stringId={'information/giveContext/linkedBankError'} />;
		}
	}

	return (
		<Flex flexDirection="column" alignItems="center">
			<Text
				textStyle="headerSmall"
				className="mb-contentXS"
				textAlign="center"
				data-testid="link-plaid-reason-header"
			>
				<BanjoString stringId={'information/error/linkBankUnsuccessful'} />
			</Text>
			<Text
				textStyle="bodyMediumStandard"
				className="mt-content2XS"
				data-testid="link-plaid-reason-context"
			>
				{renderContext(reason)}
			</Text>
			<Flex
				width="100%"
				justifyContent="center"
				className="my-contentMedium px-contentXS"
			>
				<ButtonStandard
					size="XL"
					variant="primary"
					onClick={() => {
						dismiss();
					}}
				>
					<BanjoString stringId={'action/progress/dismissMessage'} />
				</ButtonStandard>
			</Flex>
		</Flex>
	);
};

LinkPlaidReason.propTypes = {
	reason: PropTypes.string,
	dismiss: PropTypes.func,
};

export default LinkPlaidReason;
